<template>
  <div>
    <div class="navless-layout-header">
      <slot name='navbar'>
        <ed-button :to='$routerHistory.previous().path'>
          <i class="fal fa-chevron-left"></i>
          &nbsp;
          Back
        </ed-button>
        <a class="pull-right list submit-btn"
           @click='addFunds'
           :class="{ 'disabled': isDisabled }">
        <strong>Submit</strong>
        </a>
        <span class="center-span">{{ isUserAdmin ? 'Add Funds' : 'Request Funds' }}</span>
      </slot>
    </div>
    <div slot="body" :endpoint="loadingEndpoint">
      <br />
      <p class="small">Your request will be sent to your card administrator for approval.</p>
      <div v-if="isUserAdmin">
        <label>Current Balance</label> <br />
        <v-money class="small" currency="USD" locale="en">{{ accBalance }}</v-money>
        <br />
        <br />
      </div>
      <label>Funding Amount</label>
      <ed-input type='money' amount v-model='fundingAmount'>
      </ed-input>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus'
export default {
  alias: 'evedpayrequestaddfunds',
  data() {
    return {
      fundingAmount: '',
      cardId: this.$route.query.cardid,
      accBalance: this.$route.query.accBalance,
      loadingEndpoint: '',
      isDisabled: false
    }
  },
  computed: {
    isUserAdmin() {
      if (this.$user.$.userPermissions.includes('EvedPayCardAdministrator')) {
        return true
      }
      return false
    }
  },
  methods: {
    async addFunds() {
      this.isDisabled = true
      if (this.fundingAmount <= 0 || this.fundingAmount > this.accBalance) {
        alert('The amount cannot be 0, negative, or exceed the current balance.')
        this.isDisabled = false
        return
      }

      if (!this.isUserAdmin) {
        this.loadingEndpoint = `evedpaycards/${this.cardId}/request-funds`
        try {
          const response = await this.api.post(`evedpaycards/${this.cardId}/request-funds`, {
            Amount: parseFloat(this.fundingAmount)
          })

          if (response.status === 200) {
            EventBus.$emit('fundsAdded')
            this.$router.push({
              path: `/evedpay/details?cardid=${this.cardId}`,
              query: {
                ...this.$route.query,
                ...this.$route.query.cardNumber
              }
            })
          } else {
            alert('Error while requesting funds.')
            this.isDisabled = false
          }
        } catch (error) {
          this.isDisabled = false
          console.error(error)
        }
      } else {
        this.loadingEndpoint = `evedpaycards/${this.cardId}/add-funds`
        try {
          const response = await this.api.post(`evedpaycards/${this.cardId}/add-funds`, {
            Amount: parseFloat(this.fundingAmount)
          })

          if (response.status === 200) {
            EventBus.$emit('fundsAdded')
            this.$router.push({
              path: `/evedpay/details?cardid=${this.cardId}`,
              query: {
                ...this.$route.query,
                ...this.$route.query.cardNumber
              }
            })
          } else {
            alert('Error while requesting funds.')
            this.isDisabled = false
          }
        } catch (error) {
          console.error(error)
          this.isDisabled = false
        }
      }
      this.fundingAmount = ''
      this.isDisabled = false
    }
  }
}
</script>

<style lang='scss' scoped>
@import "~@/assets/sass/_variables.scss";

.submit-btn {
  padding-left: 20px;
}

.disabled {
  pointer-events: none;
  opacity: 0.6;
  cursor: not-allowed;
}

.center-span {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/EvedPay/requestAddFunds.vue